import { call, put, takeLatest } from "redux-saga/effects";
import { chuyenNganhApi } from "../../../api/category/chuyenNganhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eDmChuyenNganhActionIds } from "../../action-types/category/IDmChuyenNganhActions";
import { rootActions } from "../../actions/rootActions";

export function* chuyenNganhSaga(): any {
  yield takeLatest(eDmChuyenNganhActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(chuyenNganhApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.chuyenNganh.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.chuyenNganh.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
